module.exports = __webpack_public_path__ + "img/KURSK.87b66e2a.png";